import React from "react";
import { IoLocationSharp } from "react-icons/io5";

export default function Contact({ VenuesDetails }) {
  function isValidHttpUrl(url) {
    try {
      const u = new URL(url);
      return u.protocol === "http:" || u.protocol === "https:";
    } catch (e) {
      return false;
    }
  }
  
  return (
    <div className="details-section">
      <h4>Contact</h4>
      {VenuesDetails?.map_url ||
        (isValidHttpUrl(VenuesDetails.map_url) && (
          <div
            style={{
              marginTop: 20,
              width: "100%",
              overflow: "hidden",
              border: "1px solid #eee",
            }}
          >
            <iframe
              title={VenuesDetails?.name + " Map"}
              src={VenuesDetails?.map_url}
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        ))}

      <div
        className="border"
        style={{ padding: 15, borderRadius: 10, marginTop: 20 }}
      >
        <IoLocationSharp
          style={{ marginRight: 10, fontSize: 20, color: "maroon" }}
        />
        {[
          VenuesDetails?.address1,
          VenuesDetails?.address2,
          VenuesDetails?.city,
          VenuesDetails?.state,
          VenuesDetails?.country,
          VenuesDetails?.phone,
          VenuesDetails?.pincode,
        ].join(", ")}
      </div>
    </div>
  );
}
